import { withNaming } from "@bem-react/classname";

export const cn = withNaming({ e: "__", m: "--", v: "_" });